export default __webpack_public_path__ + "static/media/leaderboard.3c297934.svg";